import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { SalesProfileScore } from '../sales-profile-questionnaire/sales-profile-scoring';
import { SalesProfilePlan } from 'app/api/services/sales-profile.service';

@Component({
  selector: 'app-sales-profile-result',
  templateUrl: './sales-profile-result.component.html',
  styleUrls: ['./sales-profile-result.component.scss'],
  standalone: false,
})
export class SalesProfileResultComponent {
  @Input() score: SalesProfileScore | null = null;
  /** AI-generated plan (summary + described focus areas). Null while loading
   *  or when generation failed (falls back to the score's focus-area names). */
  @Input() plan: SalesProfilePlan | null = null;
  @Input() loading = false;
  @Output() close = new EventEmitter<void>();

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.score) {
      this.onClose();
    }
  }

  onClose(): void {
    this.close.emit();
  }
}
